export const REWARD_BEHAVIOR_TYPE = [
	{
		name: "Early Pickup",
		value: 1,
	},
	{
		name: "Total Packages Claimed",
		value: 2,
	},
];

export const campaignStatusOptions = [
	{
		name: "Active",
		value: 1,
	},
	{
		name: "Expired",
		value: 2,
	},
	{
		name: "Redeemed",
		value: 3,
	},
	{
		name: "Upcoming",
		value: 4,
	},
];

export const rewardType = [
	{ name: "MBOX Coins", value: 1 },
	{ name: "Prize", value: 2 },
];

export const dateFilters = [
	{ value: "1", name: "Last 30 days" },
	{ value: "2", name: "Quarter to Date" },
	{ value: "3", name: "Year to Date" },
	{ value: "4", name: "Custom Range" },
];
